export class BaseDto {
    Id: string = undefined;
    createdBy: string = undefined;
    createdDate: string = undefined;
    modifiedBy: string = undefined;
    modifiedDate: string = undefined;
}